import { Routes, Route } from "react-router-dom";
import RequireAuth from "@/components/auth/RequireAuth";
import Page404 from "@/pages/404";
import { routes, privateRoutes } from "./routes";
import { PageLayout } from "@/components/layouts";
import Login from "@/pages/login";
import ApiLoading from "@/components/common/ApiLoading";
import { useAppSelector } from "@/hooks";
import { getIsApiLoading } from "@/store/appSlice";

const Router = () => {
  const apiLoading = useAppSelector(getIsApiLoading);

  return (
    <>
    <ApiLoading open={apiLoading} />
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<PageLayout />}>
        {routes.map((routeProps) => (
          <Route {...routeProps} key={routeProps.path as string} />
        ))}
        <Route element={<RequireAuth />}>
          {privateRoutes.map((privateRouteProps) => (
            <Route {...privateRouteProps} key={`privateRoute-${privateRouteProps.path}`} />
          ))}
        </Route>
      </Route>
      <Route path="*" element={<Page404 />} />
    </Routes>
    </>
  )
};

export default Router;
